<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-05-11 12:03:04
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-09-01 09:34:55
 * @FilePath: \newsmartmapout\src\views\response.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="reponseBody">
    <div id="map"></div>
    <div class="warningBox33" v-show="!isShowMainBox">
      <div class="weatherTitle">
        <div class="weatherTitText" @click="openPopBox('warning')">
          预警列表
          <span class="showCanclick">(历史可查看)</span>
        </div>
      </div>
      <div class="warningMainBox">
        <vue-seamless-scroll :data="newwarningTableData" :class-option="classOption" class="warp">
          <div
            class="warningMainBoxItem"
            :style="{color:item.leaveType}"
            v-for="item in newwarningTableData"
            :key="item.time"
          >
            <div>{{item.headline}}</div>
            <div class="warningBtn" @click="showAraeWarningMap(item)">查看</div>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
    <div class="warningBox55" v-show="!isShowMainBox">
      <div class="weatherTitle">
        <div class="weatherTitText" @click="openPopBox('calculation')">
          预警推算
          <span class="showCanclick">(历史可查看)</span>
        </div>
      </div>
      <div class="warningMainBox">
        <vue-seamless-scroll :data="extrapolateData" :class-option="classOption" class="warp">
          <div class="warningMainBoxItem22" v-for="item in extrapolateData">
            <div class="waringtext">
              <!-- {{item.area}} -->
              <p>预报类型：暴雨预警</p>
              <p>起报时间：{{getTime(item.datetime)}}</p>
              <p>预报时间：{{item.forcastTime }}</p>
              <p :style="{color:getcolor(item.level).color}">预报等级：{{getcolor(item.level).text}}</p>
            </div>
            <div class="warningBtn22" @click="showTuisTomap(item)">查看</div>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
    <div class="reponseMainBoxre" v-show="isShowMainBox">
      <div class="colortableBtnBox">
        <img
          src="../assets/Frame_1714.png"
          @click="isShowMainBox=false"
          style="width:100%;height:100%"
          alt
        />
      </div>
      <div class="tableType">
        <el-radio-group v-model="tableTypeChoose">
          <el-radio label="warning">预警列表</el-radio>
          <el-radio label="calculation">预警推算</el-radio>
          <!-- <el-radio label="histryData">历史查询</el-radio> -->
          <el-radio label="user">人员列表</el-radio>
        </el-radio-group>
      </div>
      <div class="weatherTitlere">预警信息互应</div>
      <div class="chooseTypeBar">
        <div class="chooseTypeBarItem2" v-show="tableTypeChoose=='calculation'">
          <div style="width:atuo">查询时间：</div>

          <el-date-picker
            style="width:80%"
            size="mini"
            v-model="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getextrapolateData"
          ></el-date-picker>
        </div>

        <div class="chooseTypeBarItem2" v-show="tableTypeChoose=='warning'">
          <div style="width:atuo">预警时间：</div>

          <el-date-picker
            style="width:80%"
            size="mini"
            v-model="warningTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="timeChange"
          ></el-date-picker>
        </div>
        <div class="chooseTypeBarItem" v-show="tableTypeChoose=='warning'">
          预警类型：
          <el-select
            class="myNEwchoose"
            v-model="waringType"
            @change="typeChange"
            size="mini"
            placeholder="请选择"
          >
            <el-option label="全部" value="全部"></el-option>
            <el-option label="高温" value="高温"></el-option>
            <el-option label="大雾" value="大雾"></el-option>
            <el-option label="低温" value="低温"></el-option>
            <el-option label="暴雨" value="暴雨"></el-option>
            <el-option label="雷电" value="雷电"></el-option>
          </el-select>
        </div>
        <div class="chooseTypeBarItem" v-show="tableTypeChoose=='warning'">
          预警时效：
          <el-select
            class="myNEwchoose"
            @change="typeChange"
            v-model="waringTimeType"
            size="mini"
            placeholder="请选择"
          >
            <el-option label="全部" value="全部"></el-option>
            <el-option label="已失效" value="已失效"></el-option>
            <el-option label="生效中" value="生效中"></el-option>
          </el-select>
        </div>
        <div class="chooseTypeBarItem" v-show="tableTypeChoose=='warning'">
          预警等级：
          <el-select
            class="myNEwchoose"
            @change="typeChange"
            v-model="waringLeaveType"
            size="mini"
            placeholder="请选择"
          >
            <el-option label="全部" value="全部"></el-option>
            <el-option label="红色预警" value="red"></el-option>
            <el-option label="黄色预警" value="yellow"></el-option>
            <el-option label="蓝色预警" value="blue"></el-option>
          </el-select>
        </div>
        <div class="chooseTypeBarItem" v-show="tableTypeChoose=='warning'">
          预警区域：
          <el-select
            class="myNEwchoose"
            @change="typeChange"
            v-model="waringAreaType"
            size="mini"
            placeholder="请选择"
          >
            <el-option label="全市" value="全市"></el-option>
            <el-option label="石棉" value="石棉"></el-option>
            <el-option label="荥经" value="荥经"></el-option>
          </el-select>
        </div>
        <div class="chooseTypeBarItem" v-show="tableTypeChoose=='user'">
          负责区域：
          <el-select
            class="myNEwchoose"
            @change="typeChange2"
            v-model="waringAreaType2"
            size="mini"
            placeholder="请选择"
          >
            <el-option label="全市" value="全市"></el-option>
            <el-option label="美罗乡" value="美罗乡"></el-option>
            <el-option label="迎政乡" value="迎政乡"></el-option>
            <el-option label="宰羊乡" value="宰羊乡"></el-option>
            <el-option label="丰乐乡" value="丰乐乡"></el-option>
          </el-select>
        </div>

        <el-button
          type="primary"
          size="mini"
          v-show="tableTypeChoose=='user'"
          @click="isSHowaddPop=true"
        >新增人员</el-button>
      </div>
      <div class="myTbaleBox">
        <el-table
          :data="extrapolateData"
          border
          v-loading="extrapolateDataLoading"
          style="width: 100%"
          v-show="tableTypeChoose=='calculation'"
          height="600"
        >
          <el-table-column prop="area" label="影响区域"></el-table-column>
          <el-table-column prop="area" label="预警类型">
            <template slot-scope="scope">
              暴雨预警
              <!-- </el-popover> -->
            </template>
          </el-table-column>
          <el-table-column prop="area" label="预警等级">
            <template slot-scope="scope">
              <el-tag size="medium" :color="scope.row.color">{{scope.row.text}}</el-tag>

              <!-- </el-popover> -->
            </template>
          </el-table-column>
          <el-table-column prop="mj" label="影响面积(平方千米)"></el-table-column>
          <el-table-column prop="forcastTime" label="预测时间"></el-table-column>
          <el-table-column label="操作" width="350">
            <template slot-scope="scope">
              <div class="myBtnBox">
                <el-button
                  size="mini"
                  type="primary"
                  @click="showchooseUserPop('pushmsegTotel',scope.row)"
                >短信</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  @click="showchooseUserPop('pushMsgToemaile',scope.row)"
                >邮件</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  @click="showchooseUserPop('callUsers',scope.row)"
                >呼叫</el-button>
                <!-- <el-popconfirm title="确认推送短信吗？" @confirm="pushmsegTotel">
                  <el-button size="mini" type="primary" slot="reference">短信</el-button>
                </el-popconfirm>
                <el-popconfirm title="确认推送邮件吗？" @confirm="pushMsgToemaile">
                  <el-button size="mini" type="primary" slot="reference">邮件</el-button>
                </el-popconfirm>
                <el-popconfirm title="确认呼叫吗？" @confirm="callUsers">
                  <el-button size="mini" type="primary" slot="reference">呼叫</el-button>
                </el-popconfirm>-->

                <!-- <el-button size="mini" type="primary" @click="dialogVisible=true">应对建议</el-button> -->

                <!-- <el-button size="mini" type="primary">邮件</el-button>
                <el-button size="mini" type="primary">呼叫</el-button>
                <el-button size="mini" type="primary">应对建议</el-button>-->
              </div>

              <!-- <el-button size="mini" type="primary">反馈</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="newwarningTableData"
          border
          style="width: 100%"
          v-show="tableTypeChoose=='warning'"
          height="600"
        >
          <el-table-column prop="headline" label="预警内容" width="200"></el-table-column>
          <el-table-column prop="startTime" label="开始时间" width="200"></el-table-column>
          <el-table-column prop="endTime" label="结束时间" width="200"></el-table-column>
          <el-table-column prop="endTime" label="预警等级" width="100">
            <template slot-scope="scope">
              <el-tag
                size="medium"
                :color="scope.row.leaveType"
              >{{getwaringLaver3(scope.row.leaveType)}}</el-tag>

              <!-- </el-popover> -->
            </template>
          </el-table-column>
          <el-table-column prop="text2" label="次生灾害" align="center">
            <template slot-scope="scope">-----</template>
          </el-table-column>
          <el-table-column prop="areanum2" label="影响面积" align="center">
            <template slot-scope="scope">-----</template>
          </el-table-column>
          <el-table-column prop="area" label="影响区域" align="center">
            <template slot-scope="scope">-----</template>
          </el-table-column>
          <el-table-column prop="endTime" label="是否反馈">
            <template slot-scope="scope">
              <el-tag size="medium">已反馈</el-tag>

              <!-- </el-popover> -->
            </template>
          </el-table-column>
          <el-table-column label="操作" width="350"  fixed="right">
            <template slot-scope="scope">
              <div class="myBtnBox">
                <el-button
                  size="mini"
                  type="primary"
                  @click="showchooseUserPop('pushmsegTotel',scope.row)"
                >短信</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  @click="showchooseUserPop('pushMsgToemaile',scope.row)"
                >邮件</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  @click="showchooseUserPop('callUsers',scope.row)"
                >呼叫</el-button>
                 
                <!-- <el-popconfirm title="确认推送短信吗？" @confirm="pushmsegTotel">
                  <el-button size="mini" type="primary" slot="reference">短信</el-button>
                </el-popconfirm>
                <el-popconfirm title="确认推送邮件吗？" @confirm="pushMsgToemaile">
                  <el-button size="mini" type="primary" slot="reference">邮件</el-button>
                </el-popconfirm>
                <el-popconfirm title="确认呼叫吗？" @confirm="callUsers">
                  <el-button size="mini" type="primary" slot="reference">呼叫</el-button>
                </el-popconfirm>-->

                <el-button
                  size="mini"
                  type="primary"
                  @click="openMsgBox(scope.row.type,scope.row.level)"
                >应对建议</el-button>
                 <el-button
                  size="mini"
                  type="success"
                  @click="openDelData(scope.row.description)"
                >详情</el-button>
                <!-- <el-button size="mini" type="primary">邮件</el-button>
                <el-button size="mini" type="primary">呼叫</el-button>
                <el-button size="mini" type="primary">应对建议</el-button>-->
              </div>

              <!-- <el-button size="mini" type="primary">反馈</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="extrapolateData2"
          border
          style="width: 100%"
          v-show="tableTypeChoose=='histryData'"
        >
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="username" label="负责人名称212"></el-table-column>
          <el-table-column prop="mail" label="邮件地址" width="400"></el-table-column>
          <el-table-column prop="phonenum" label="电话号码"></el-table-column>
          <el-table-column prop="region" label="负责区域"></el-table-column>
          <el-table-column prop="area" label="操作">
            <template slot-scope="scope">
              <div class="myBtnBox2">
                <el-button
                  size="mini"
                  type="primary"
                  slot="reference"
                  @click="eidtUser(scope.row)"
                >修改</el-button>
                <el-popconfirm title="确认删除吗？" @confirm="delhandeller(scope.row)">
                  <el-button size="mini" type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="newuserData" border style="width: 100%" v-show="tableTypeChoose=='user'">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="username" label="负责人名称"></el-table-column>
          <el-table-column prop="mail" label="邮件地址" width="400"></el-table-column>
          <el-table-column prop="phonenum" label="电话号码"></el-table-column>
          <el-table-column prop="region" label="负责区域"></el-table-column>
          <el-table-column prop="area" label="操作">
            <template slot-scope="scope">
              <div class="myBtnBox2">
                <el-button
                  size="mini"
                  type="primary"
                  slot="reference"
                  @click="eidtUser(scope.row)"
                >修改</el-button>
                <el-popconfirm title="确认删除吗？" @confirm="delhandeller(scope.row)">
                  <el-button size="mini" type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="应对建议"
        :modal-append-to-body="false"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <p>{{msgStr}}</p>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">下 载</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="信息修改"
        :modal-append-to-body="false"
        :visible.sync="isSHowEditPop"
        width="30%"
      >
        <el-form :model="usereidtData" :rules="rules" label-width="100px" ref="ruleeidtForm">
          <el-form-item label="负责人名称" prop="username">
            <el-input placeholder="请输入内容" v-model="usereidtData.username"></el-input>
          </el-form-item>
          <el-form-item label="邮件地址" prop="mail">
            <el-input placeholder="请输入内容" v-model="usereidtData.mail"></el-input>
          </el-form-item>
          <el-form-item label="电话号码" prop="phonenum">
            <el-input placeholder="请输入内容" v-model="usereidtData.phonenum"></el-input>
          </el-form-item>
          <el-form-item label="负责区域" prop="region">
            <el-select
              class="myNEwchoose"
              v-model="usereidtData.region"
              placeholder="请选择"
              style="width:100%"
            >
              <el-option label="全市" value="全市"></el-option>
              <el-option label="美罗乡" value="美罗乡"></el-option>
              <el-option label="迎政乡" value="迎政乡"></el-option>
              <el-option label="宰羊乡" value="宰羊乡"></el-option>
              <el-option label="丰乐乡" value="丰乐乡"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="isSHowEditPop = false">取 消</el-button>
            <el-button type="primary" @click="submitEditData('ruleeidtForm')">保 存</el-button>
          </el-form-item>
        </el-form>

        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="isSHowEditPop = false">取 消</el-button>
          <el-button type="primary" @click="submitEditData">保 存</el-button>
        </span>-->
      </el-dialog>
      <el-dialog
        title="新增人员"
        :modal-append-to-body="false"
        :visible.sync="isSHowaddPop"
        width="30%"
      >
        <el-form :model="addUserInfo" :rules="rules" label-width="100px" ref="ruleForm">
          <el-form-item label="负责人名称" prop="user_name">
            <el-input placeholder="请输入内容" v-model="addUserInfo.user_name"></el-input>
          </el-form-item>
          <el-form-item label="邮件地址" prop="email">
            <el-input placeholder="请输入内容" v-model="addUserInfo.email"></el-input>
          </el-form-item>
          <el-form-item label="电话号码" prop="tel">
            <el-input placeholder="请输入内容" v-model="addUserInfo.tel"></el-input>
          </el-form-item>
          <el-form-item label="负责区域" prop="places">
            <el-select
              class="myNEwchoose"
              v-model="addUserInfo.places"
              placeholder="请选择"
              style="width:100%"
            >
              <el-option label="全市" value="全市"></el-option>
              <el-option label="美罗乡" value="美罗乡"></el-option>
              <el-option label="迎政乡" value="迎政乡"></el-option>
              <el-option label="宰羊乡" value="宰羊乡"></el-option>
              <el-option label="丰乐乡" value="丰乐乡"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="isSHowaddPop = false">取 消</el-button>
            <el-button type="primary" @click="addUserInfohandeller('ruleForm')">保 存</el-button>
            <!-- <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button> -->
          </el-form-item>
        </el-form>

        <!-- <el-input placeholder="请输入内容" style="margin-top:10px" v-model="usereidtData.area">
          <template slot="prepend">负责区域</template>
        </el-input>-->

        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="isSHowaddPop = false">取 消</el-button>
          <el-button type="primary" @click="addUserInfohandeller">保 存</el-button>
        </span>-->
      </el-dialog>
    </div>
    <el-dialog
      title="选择推送人员"
      :visible.sync="isShowChooseUserPop"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <el-checkbox-group v-model="chooseUserListArr">
        <el-checkbox :label="item" v-for=" item in userData">{{item.username}}({{item.region}})</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowChooseUserPop = false">取 消</el-button>
        <el-button type="primary" @click="sendMsgTouser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { MapCreate, legendColor } from "../map/mapImport.js";
import yaan from "../map/china.json";
import moment from "moment";
import waringIcon from "../assets/waringIcon.png";
import vueSeamlessScroll from "vue-seamless-scroll";
import china from "../map/china.json";
import jsCookie from "js-cookie";
// import warningIcon from "../assets/icon"
export default {
  data() {
    return {
      warnAreaLayer:null,
      extrapolateDataLoading: false,
      datetime: [
        moment()
          .subtract(1, "d")
          .format("YYYY-MM-DD HH:00:00"),
        moment().format("YYYY-MM-DD HH:00:00")
      ],
      datetime1: "",
      areaNameLayer: null,
      msgStr: "",
      msgListData: [],
      chooseTelList: "",
      choosemailList: "",
      chooseUserListArr: [],
      isShowChooseUserPop: false,
      classOption: {
        step: 0.2,
        singleWidth: 0,
        direction: 1
      },
      watherLayer: null,
      isShowMainBox: false,
      warningTime: [
        moment()
          .subtract(1, "d")
          .format("YYYY-MM-DD HH:00:00"),
        moment().format("YYYY-MM-DD HH:00:00")
      ],
      rules: {
        user_name: [
          { required: true, message: "请输入负责人名称", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" }
        ],
        username: [
          { required: true, message: "请输入负责人名称", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" }
        ],
        email: [
          {
            type: "email",
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          }
        ],
        mail: [
          {
            type: "email",
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          }
        ],
        tel: [
          { required: true, message: "请输入负责人电话号码", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确号码", trigger: "blur" }
        ],
        phonenum: [
          { required: true, message: "请输入负责人电话号码", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确号码", trigger: "blur" }
        ],
        places: [
          { required: true, message: "请选择负责区域", trigger: "change" }
        ],
        region: [
          { required: true, message: "请选择负责区域", trigger: "change" }
        ]
      },
      waringAreaType2: "全市",
      isSHowEditPop: false,
      tableTypeChoose: "warning",
      dialogVisible: false,
      mpa: null,
      waringType: "全部",
      waringTimeType: "全部",
      waringLeaveType: "全部",
      waringAreaType: "全市",
      newuserData: [],
      userData: [],
      newwarningTableData: [
        {
          headline: "石棉发布暴雨红色预警",
          startTime: "2024-03-28 12:00:00",
          endTime: "2024-03-28 16:00:00",
          level: "红色预警",
          text: "可能造成相关区域地质灾害（滑坡）",
          areanum: "242平方千米",
          area: "美罗乡,迎政乡,宰羊乡,丰乐乡",
          tel: "182xxxxxxxx 王xx",
          leaveType: "red",
          type: "暴雨",
          timeer: "生效中",
          city: "石棉"
        },
        {
          headline: "石棉发布大雾黄色预警",
          startTime: "2024-03-28 12:00:00",
          endTime: "2024-03-28 16:00:00",
          level: "黄色预警",
          text: "可能造成相关区域地质灾害（滑坡）",
          areanum: "242平方千米",
          area: "美罗乡,迎政乡,宰羊乡,宰羊乡",
          tel: "182xxxxxxxx 王xx",
          leaveType: "yellow",
          type: "大雾",
          timeer: "生效中",
          mycity: "石棉"
        },
        {
          headline: "荥经发布暴雨黄色预警",
          startTime: "2024-03-28 12:00:00",
          endTime: "2024-03-28 16:00:00",
          level: "黄色预警",
          text: "可能造成相关区域地质灾害（滑坡）",
          areanum: "242平方千米",
          area: "美罗乡,迎政乡,宰羊乡,丰乐乡",
          tel: "182xxxxxxxx 王xx",
          leaveType: "yellow",
          type: "暴雨",
          timeer: "已失效",
          mycity: "荥经"
        },
        {
          headline: "石棉发布高温黄色预警",
          startTime: "2024-03-28 12:00:00",
          endTime: "2024-03-28 16:00:00",
          level: "黄色预警",
          text: "可能造成相关区域地质灾害（滑坡）",
          areanum: "242平方千米",
          area: "美罗乡,迎政乡,宰羊乡,丰乐乡",
          tel: "182xxxxxxxx 王xx",
          leaveType: "yellow",
          type: "高温",
          timeer: "生效中",
          mycity: "石棉"
        }
      ],
      warningTableData: [
        {
          headline: "石棉发布暴雨红色预警",
          startTime: "2024-03-28 12:00:00",
          endTime: "2024-03-28 16:00:00",
          level: "红色预警",
          text: "可能造成相关区域地质灾害（滑坡）",
          areanum: "242平方千米",
          area: "美罗乡,迎政乡,宰羊乡,丰乐乡",
          tel: "182xxxxxxxx 王xx",
          leaveType: "red",
          type: "暴雨",
          timeer: "生效中",
          mycity: "石棉"
        },
        {
          headline: "石棉发布大雾黄色预警",
          startTime: "2024-03-28 12:00:00",
          endTime: "2024-03-28 16:00:00",
          level: "黄色预警",
          text: "可能造成相关区域地质灾害（滑坡）",
          areanum: "242平方千米",
          area: "美罗乡,迎政乡,宰羊乡,丰乐乡",
          tel: "182xxxxxxxx 王xx",
          leaveType: "yellow",
          type: "大雾",
          timeer: "生效中",
          mycity: "石棉"
        },
        {
          headline: "荥经发布暴雨黄色预警",
          startTime: "2024-03-28 12:00:00",
          endTime: "2024-03-28 16:00:00",
          level: "黄色预警",
          text: "可能造成相关区域地质灾害（滑坡）",
          areanum: "242平方千米",
          area: "美罗乡,迎政乡,宰羊乡,丰乐乡",
          tel: "182xxxxxxxx 王xx",
          leaveType: "yellow",
          type: "暴雨",
          timeer: "已失效",
          mycity: "荥经"
        },
        {
          headline: "石棉发布高温黄色预警",
          startTime: "2024-03-28 12:00:00",
          endTime: "2024-03-28 16:00:00",
          level: "黄色预警",
          text: "可能造成相关区域地质灾害（滑坡）",
          areanum: "242平方千米",
          area: "美罗乡,迎政乡,宰羊乡,丰乐乡",
          tel: "182xxxxxxxx 王xx",
          leaveType: "yellow",
          type: "高温",
          timeer: "生效中",
          mycity: "石棉"
        }
      ],
      addUserInfo: {
        user_name: "",
        tel: "",
        email: "",
        places: ""
      },
      usereidtData: {},
      isSHowaddPop: false,
      sendType: "",
      chooseWaringText: "",
      extrapolateData: [],
      userareaCode: "511800",
      userObjInfo: {},
      extrapolateData2: [],
      tilePixelLayer:null
    };
  },
  mounted() {
    // isShowMainBox
    if(this.$route.params.isopen){
      this.isShowMainBox= true
    }
    this.map = new MapCreate();
    //   this.map.init();
    this.map.init("map");
    let layerJson = china;
    let myuserinfo = JSON.parse(jsCookie.get("areainfo"));
    // console.log(myuserinfo);
    this.userObjInfo = myuserinfo;
    // console.log(this.userObjInfo);
    this.userareaCode = myuserinfo.areaCode;
    let style = {
      color: "#FCB042", //线颜色
      weight: 5, //线粗细
      opacity: 1, //透明度
      opacity: 1,
      fillColor: "#2F5B00", //区域填充颜色
      fillOpacity: 0 //区域填充颜色的透明
    };
    let areaNameList = [];
    let t = this;
    if (this.userareaCode == "511800") {
      let myAreaLayer = L.geoJSON(china.features, {
        style: style,

        onEachFeature: e => {
          // console.log(2212121);
          let print = t.getPolygon(e.geometry.coordinates[0][0]);
          console.log(print);
          console.log(e.properties.name);
          let myIcon = L.divIcon({
            html: `<div class="myareaNameBox" style="font-size: 12px;width:100px;text-align:center;  font-weight: 800;
                  ">${e.properties.name}</div>`,
            className: "my-div-icon",
            iconSize: [50, 50],
            bgPos: [-50, -50]
          });
          let mymarker = L.marker(print, { icon: myIcon });
          areaNameList.push(mymarker);
        }
      }).addTo(this.map.map);
      this.areaNameLayer = L.layerGroup(areaNameList).addTo(this.map.map);
      L.mask(china.features, {
        fillOpacity: 0.5,
        fillColor: "#04777A",
        color: "#04777A",
        opacity: 0,
        fitBounds: false,
        restrictBounds: false
      }).addTo(this.map.map);
      this.map.map.flyToBounds(myAreaLayer.getBounds());
    } else {
      china.features.map(item => {
        // console.log(item);
        if (item.properties.adcode == this.userareaCode) {
          layerJson = item;
        }
      });
      let myAreaLayer = L.geoJSON(layerJson, { style: style }).addTo(
        this.map.map
      );
      L.mask(layerJson, {
        fillOpacity: 0.5,
        fillColor: "#04777A",
        color: "#04777A",
        opacity: 0,
        fitBounds: false,
        restrictBounds: false
      }).addTo(this.map.map);
      this.map.map.flyToBounds(myAreaLayer.getBounds());
    }
    window.funName = this.showBox;
  },
  destroyed() {
    console.log("beforeDestory");
    this.map.map.remove();
  },
  created() {
    let myuserinfo = JSON.parse(jsCookie.get("areainfo"));
    console.log(myuserinfo.areaCode);
    this.userareaCode = myuserinfo.areaCode;
    this.getUserData();
    this.getWaringList();
    this.getextrapolateData();
    this.getMsgListArr();
    // this.getextrapolateData2();

    console.log(name);
  },
  components: {
    vueSeamlessScroll
  },
  methods: {
    showAraeWarningMap(data){
       if (this.warnAreaLayer) {
          this.map.map.removeLayer(this.warnAreaLayer);
          this.warnAreaLayer = null;
        }
      this.warnAreaLayer=  L.geoJSON(china.features, {
        style: function(feature) {
          // let found = data.find(
          //   element => element.geocode == feature.properties.adcode
          // );
          console.log(data.geocode);
          console.log(feature.properties.adcode);
          if (data.geocode == feature.properties.adcode) {
            return { color: data.leaveType, fillOpacity: 0.7 };
          } else {
            return { fillOpacity: 0, opacity: 0 };
          }
        }
      }).addTo(this.map.map);
    },
    showTuisTomap(data){
        if (this.warnAreaLayer) {
          this.map.map.removeLayer(this.warnAreaLayer);
          this.warnAreaLayer = null;
        }
      console.log(data);
       let ledcolorList = JSON.parse(JSON.stringify(legendColor["warning"]));
        ledcolorList.map((item, index) => {
          ////console.log(index);
          if (index == 0) {
            return (item[1][3] = 0);
          } else {
            return (item[1][3] = 0.25);
          }
        });
        console.log(data.datas.split(","));
        let t = this;
        this.warnAreaLayer = L.tilePixelLayer({
          newData: data.datas.split(","),
          data: data,
          gradient: ledcolorList
          // clickEvt: function(e, gridValue) {
          //   console.log(e, gridValue);
          //   let popup = L.popup()
          //     .setLatLng([e.latlng.lat, e.latlng.lng])
          //     .setContent(`<div>${t.checkList}值:${gridValue}</div>`)
          //     .openOn(t.map.map);
          // }
        });
        // this.map.map.on("layeradd", () => {
        //   console.log("layeradd");
        //   this.map.map.removeLayer(oldTitle);
        // });
        this.map.map.addLayer(this.warnAreaLayer);
    },
    getextrapolateData2() {
      let formData = new FormData();

      formData.append("datetime", datetime[0]);
      formData.append("datetime1", datetime[1]);
      formData.append("areaCode", `null`);
      formData.append("element", `rain`);
      formData.append("forcastEndTime", `null`);
      formData.append("forcastStartTime", `null`);
      formData.append("type", `null`);
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/warn/getForcastWarn`,
        data: formData
      }).then(res => {
        console.log(res.data.datas);
        if (res.data.datas.length == 0) {
          this.extrapolateData2 = [];
        } else {
        }

        // //console.log(res.data.datas[0]);
      });
    },
    timeChange(e) {
      console.log(e);
      this.warningTime = e;
      this.getWaringList();
    },
    timeChange2(e) {
      console.log(e);
      // this.warningTime = e;
      // this.getWaringList();
    },
    getPolygon(pList) {
      var area = 0;
      var x = 0;
      var y = 0;
      for (var i = 1; i <= pList.length; i++) {
        var lat = pList[i % pList.length][0];
        var lng = pList[i % pList.length][1];
        var nextLat = pList[i - 1][0];
        var nextLng = pList[i - 1][1];
        var temp = (lat * nextLng - lng * nextLat) / 2;
        area += temp;
        x += (temp * (lat + nextLat)) / 3;
        y += (temp * (lng + nextLng)) / 3;
      }
      x = x / area;
      y = y / area;
      return [y, x];
    },
    getTime(data) {
      return moment(data).format("YYYY-MM-DD HH:mm:ss");
    },
    openPopBox(type) {
      this.tableTypeChoose = type;
      this.isShowMainBox = true;
    },
    openMsgBox(type, lev) {
      console.log(type);

      this.dialogVisible = true;
      let newtype = lev;
      if (lev == "黄色预警") {
        newtype = "黄色";
      } else if (lev == "橙色预警") {
        newtype = "橙色";
      } else if (lev == "红色预警") {
        newtype = "红色";
      }
      console.log(newtype);
      let str = this.msgListData.filter(
        item => item.WARNINGTYPE == type && item.WARNINGLEVEL == newtype
      );
      console.log(str);
      this.msgStr = str[0].DEFENSEGUIDE;
    },
    getMsgListArr() {
      this.$axios({
        method: "get",
        url: `https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getYaanYDJY`
      }).then(res => {
        // console.log();
        this.msgListData = res.data.dataList;
      });
    },
    getcolor(data) {
      if (data == 1) {
        return { color: "yellow", text: "黄色预警" };
      } else if (data == 2) {
        return { color: "orange", text: "橙色预警" };
      } else if (data == 3) {
        return { color: "red", text: "红色预警" };
      }
    },
    getextrapolateData() {
      this.extrapolateDataLoading = true;
      let formData = new FormData();

      // formData.append("datetime", '2025-08-21 12:00:00');
      formData.append("datetime", this.datetime[0]);
      formData.append("datetime1", this.datetime[1]);
      formData.append("areaCode", this.userareaCode);
      formData.append("element", `rain`);
      formData.append("forcastEndTime", "null");
      formData.append("forcastStartTime", "null");
      formData.append("type", `null`);
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/warn/getForcastWarn`,
        data: formData
      }).then(res => {
        this.extrapolateDataLoading = false;
        console.log(res.data.datas);
        res.data.datas.map(item => {
          let text = this.getcolor(item.level);
          item.color = text.color;
          item.text = text.text;
          item.description = `${item.area}暴雨${item.text}`;
          return item;
        });
        console.log(res.data.datas);
        this.extrapolateData = res.data.datas;
        // console.log(this.extrapolateData);
        // //console.log(res.data.datas[0]);
      });
    },
    getextrapolateData2() {
      let formData = new FormData();

      formData.append("datetime", moment().format("YYYY-MM-DD HH:00:00"));
      formData.append("datetime1", moment().format("YYYY-MM-DD HH:00:00"));
      formData.append("areaCode", this.userareaCode);
      formData.append("element", `rain`);
      formData.append(
        "forcastEndTime",
        moment()
          .add(24, "h")
          .format("YYYY-MM-DD HH:00:00")
      );
      formData.append(
        "forcastStartTime",
        moment().format("YYYY-MM-DD HH:00:00")
      );
      formData.append("type", `null`);
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/warn/getForcastWarn`,
        data: formData
      }).then(res => {
        console.log(res.data.datas);
        res.data.datas.map(item => {
          let text = this.getcolor(item.level);
          item.color = text.color;
          item.text = text.text;
          item.description = `${item.area}暴雨${item.text}`;
          return item;
        });
        console.log(res.data.datas);
        this.extrapolateData = res.data.datas;
        // console.log(this.extrapolateData);
        // //console.log(res.data.datas[0]);
      });
    },
    showchooseUserPop(data, text) {
      console.log(data, text);
      // console.log(text.description);
      this.isShowChooseUserPop = true;
      this.chooseUserListArr = this.userData;
      // return
      // console.log(list.toString(","));

      this.sendType = data;
      this.chooseWaringText = text.description;
    },
    sendMsgTouser() {
      let list = [];
      let list2 = [];
      this.chooseUserListArr.map(item => {
        list.push(item.phonenum);
        list2.push(item.mail);
      });
      this.chooseTelList = list.toString(",");
      this.choosemailList = list2.toString(",");
      let data = this.sendType;
      console.log(this.chooseTelList);
      console.log(this.choosemailList);
      // return;
      if (data == "pushmsegTotel") {
        this.pushmsegTotel(this.chooseWaringText);
      } else if (data == "pushMsgToemaile") {
        this.pushMsgToemaile(this.chooseWaringText);
      } else if (data == "callUsers") {
        this.callUsers(this.chooseWaringText);
      }
      this.isShowChooseUserPop = false;
    },
    openDelData(data){
       this.$alert(data, '预警详情', {
          confirmButtonText: '确定',
       
        });
    },
    getwaringLaver(data) {
      // console.log(data);
      if (data == "red") {
        return "红色预警";
      } else if (data == "orange") {
        return "橙色预警";
      } else if (data == "yellow") {
        return "黄色预警";
      } else if (data == "blue") {
        return "蓝色预警";
      }
    },
        getwaringLaver3(data) {
      // console.log(data);
      if (data == "Red") {
        return "红色预警";
      } else if (data == "Orange") {
        return "橙色预警";
      } else if (data == "Yellow") {
        return "黄色预警";
      } else if (data == "Blue") {
        return "蓝色预警";
      }
    },
    getWaringList() {
      let myuserinfo = JSON.parse(jsCookie.get("areainfo"));
      let code = "5118";
      if (this.userareaCode == 511800) {
        code = "5118";
      } else {
        code = this.userareaCode;
      }
      console.log(myuserinfo);
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/warn/getYaWarninfoByTime?startTime=${this.warningTime[0]}&endTime=${this.warningTime[1]}&areaCode=${code}`
      }).then(res => {
        console.log(res.data.datas);
        res.data.datas.map(item => {
          if (item.leaveType == "yellow") {
            item.level = "黄色预警";
          } else if (item.leaveType == "blue") {
            item.level = "蓝色预警";
          } else if (item.leaveType == "orange") {
            item.level = "橙色预警";
          }
          return item;
        });
        this.newwarningTableData = res.data.datas;
        this.warningTableData = res.data.datas;
        this.showMywariningMarker(res.data.datas);
      });
    },
    getLeaveText(data){
      if(data=='Orange'){
        return '橙色预警'
      }else if(data=='Yellow'){
        return '黄色预警'
      }else if(data=='Red'){
        return '红色预警'
      }else if(data=='Blue'){
        return '蓝色预警'
      }
    },
    showMywariningMarker(data) {
      var greenIcon = L.icon({
        iconUrl: waringIcon, //icon阴影图片路径
        className: "blinking",
        iconSize: [32, 32] // size of the icon
      });
    this.warnAreaLayer=  L.geoJSON(china.features, {
        style: function(feature) {
          let found = data.find(
            element => element.geocode == feature.properties.adcode
          );
          // console.log(found);
          if (found != undefined) {
            return { color: found.leaveType, fillOpacity: 0.7 };
          } else {
            return { fillOpacity: 0, opacity: 0 };
          }
        }
      }).addTo(this.map.map);

      let markerListData = [];
      let t = this;

      data.map(item => {
        let mymarker = L.marker([item.lat, item.lon], { icon: greenIcon })
          .bindPopup(
            `
              <p>${item.headline}</p>
              <p>开始时间:${item.startTime}</p>
              <p>结束时间:${item.endTime}</p>
              <p>预警类型:${item.type}</p>
              <p>预警等级:${t.getLeaveText(item.leaveType)}</p>
            
              <p>发布者:${item.sender}</p>
              <div style="width:80px;height:30px;  background-color: #4985aa; border: 1px solid #afedf0;text-align:center; line-height: 30px;border-radius:5px" onclick='funName()'>查看详情</div>
              `
          )
          .openPopup();

        markerListData.push(mymarker);

        // document.querySelector(".mywiconBtn").addEventListener("click", () => {
        //   console.log(21211212);
        // });
      });

      this.watherLayer = L.layerGroup(markerListData).addTo(this.map.map);
    },
    showBox() {
      this.tableTypeChoose = "warning";
      this.isShowMainBox = true;
    },
    delhandeller(data) {
      console.log(data.id);
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `
      https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=deleteYaanUserlist&thisid=${data.id}`
      }).then(() => {
        this.getUserData();
      });
    },
    submitEditData(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let formData = new FormData();
          formData.append(
            "params",
            `{
        user_name: "${this.usereidtData.username}",
        tel: "${this.usereidtData.phonenum}",
        email: "${this.usereidtData.mail}",
        places: "${this.usereidtData.region}",
        thisid: "${this.usereidtData.id}"
      }`
          );
          this.$axios({
            method: "post",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            url: `
      https://www.moodsci.com/SWDataservice/yaan/updateUserList`,
            data: formData
          }).then(res => {
            this.getUserData();
            this.isSHowEditPop = false;
            // console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      // https://www.moodsci.com/SWDataservice/yaan/updateUserList?params={"user_name":"小二","tel":"18510653504","email":"1095915643@qq.com","places":"乡","thisid":"3"}
    },
    addUserInfohandeller(formName) {
      this.$refs[formName].validate(valid => {
        console.log(valid);
        if (valid) {
          let formData = new FormData();
          formData.append("params", JSON.stringify(this.addUserInfo));
          this.$axios({
            method: "post",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            url: `
      https://www.moodsci.com/SWDataservice/yaan/insertUserList`,
            data: formData
          })
            .then(res => {
              console.log(res);
              this.isSHowaddPop = false;
              this.getUserData();
            })
            .catch(() => {
              this.isSHowaddPop = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });

      // return;
    },
    getUserData() {
      this.$axios({
        method: "post",
        url: `
      https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getYaanUserlist`
      }).then(res => {
        console.log(res.data.dataList);
        this.userData = res.data.dataList;
        this.newuserData = res.data.dataList;
      });
    },
    typeChange2(e) {
      console.log(e);
      let isfiltersName = true;
      this.newuserData = this.userData.filter(item => {
        let filtersName = e;

        if (filtersName != "全市") {
          isfiltersName = item.region.indexOf(filtersName) != -1;
        }
        return isfiltersName;
      });
    },
    eidtUser(data) {
      console.log(data);
      this.usereidtData = data;
      this.isSHowEditPop = true;
    },
    callUsers(data) {
      let formData = new FormData();
      formData.append(
        "params",
        `{"phones":"${this.chooseTelList}","sendcontent":"${data}"}`
      );
      this.$axios({
        method: "post",

        url: `
      https://www.moodsci.com/data/Send/sendSingleCall`,
        data: formData
      }).then(res => {
        console.log(res);
      });
    },
    pushMsgToemaile(data) {
      let formData = new FormData();
      formData.append(
        "params",
        `{"recipient":"${this.choosemailList}","sendcontent":"${data}"}`
      );
      this.$axios({
        method: "post",
        url: `
      https://www.moodsci.com/data/MailMonitor/sendMail`,
        data: formData
      }).then(res => {
        console.log(res);
      });
    },
    pushmsegTotel(data) {
      let formData = new FormData();
      formData.append(
        "params",
        `{"phones":"${this.chooseTelList}","sendcontent":"${data}"}`
      );
      this.$axios({
        method: "post",
        url: `
       https://www.moodsci.com/data/SendMessage/sendNote`,
        data: formData
      }).then(res => {
        console.log(res);
      });
    },
    typeChange() {
      let mylist = JSON.parse(JSON.stringify(this.warningTableData));
      // if()

      let filtersName = this.waringType;
      let filtersBrand = this.waringTimeType;
      let filtersCategory = this.waringLeaveType;
      let filtersType = this.waringAreaType;
      //筛选原始数组并赋值给filtersAutomobile数组
      let filtersAutomobile = this.warningTableData.filter(item => {
        //定义筛选条件，默认为true，这样就可以让不符合动态选择条件时不影响筛选条件
        let isFiltersName = true;
        let isFiltersBrand = true;
        let isFiltersCategory = true;
        let isFiltersType = true;
        //符合动态选择条件就给筛选条件赋值
        if (filtersName != "全部") {
          isFiltersName = item.type.indexOf(filtersName) != -1;
        }
        if (filtersBrand != "全部") {
          isFiltersBrand = item.timeer.indexOf(filtersBrand) != -1;
        }
        if (filtersCategory != "全部") {
          isFiltersCategory = item.leaveType.indexOf(filtersCategory) != -1;
        }
        if (filtersType != "全市") {
          isFiltersType = item.mycity.indexOf(filtersType) != -1;
        }
        console.log(
          isFiltersName,
          isFiltersBrand,
          isFiltersCategory,
          isFiltersType
        );
        return (
          isFiltersName && isFiltersBrand && isFiltersCategory && isFiltersType
        );
      });
      //把筛选后的数组赋值给列表显示数组
      this.newwarningTableData = filtersAutomobile;
      console.log(this.newwarningTableData);
    }
  }
};
</script>

<style lang="scss" scoped>
@function px2vw($px) {
  @return $px * 100vw / 1920;
}
.reponseBody {
  height: 100vh;
  width: 100vw;
  /* background-color: aqua; */
}
#map {
  height: 100vh;
  width: 100vw;
  position: absolute;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #8d8d8d !important;
}
.reponseMainBoxre {
  height: px2vw(800);
  width: px2vw(1700);
  background-color: white;
  position: absolute;
  z-index: 2000;
  top: px2vw(100);
  left: px2vw(110);
  border: 1px solid rgba(54, 155, 188, 1);
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
}

.colortableBtnBox {
  height: 30px;
  width: 30px;
  // background-color: red;
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 999;
}
.weatherTitlere {
  width: 100%;
  text-align: left;
  height: px2vw(48);
  display: flex;
  align-items: center;
  // justify-content: center;
  //   text-align: center;
  color: rgba(227, 236, 255, 1);
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: px2vw(20);
  line-height: px2vw(24);
  background: linear-gradient(
    89.93deg,
    rgba(35, 105, 138, 0) 0.06%,
    rgba(43, 133, 175, 0.93) 10.86%,
    rgba(35, 105, 138, 1) 72.9%,
    rgba(35, 105, 138, 0) 98.55%
  );
  /* width: 388px;
  height: 54px; */
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    90.01deg,
    rgba(255, 255, 255, 0) 0.01%,
    rgba(255, 255, 255, 0) 18.18%,
    rgba(255, 255, 255, 0) 99.66%
  );
  padding: 0px px2vw(15);
}
.chooseTypeBar {
  height: px2vw(60);
  width: 100%;
  //   background-color: aqua;
  display: flex;
  // justify-content: space-around;
  justify-content: space-between;
  align-items: center;
  padding: 0 px2vw(30);
}
.chooseTypeBarItem {
  color: white;
  width: px2vw(300);
  display: flex;
  align-items: center;
  // margin-left: px2vw(50);
}
.chooseTypeBarItem2 {
  color: white;
  width: px2vw(400);
  display: flex;
  justify-content: space-around;
  align-items: center;
  // margin-left: px2vw(50);
}
.myNEwchoose {
  width: px2vw(200);
}
.myTbaleBox {
  height: px2vw(650);
  //   background-color: aqua;
}
.myBtnBox {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.myBtnBox2 {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.tableType {
  position: absolute;
  top: px2vw(10);
  right: 50%;
}
.el-range-input {
  background-color: #1e4e4e !important;
  color: white !important;
}
.el-range-separator {
  color: white !important;
}
@keyframes wxBlinking {
  from {
    width: 32px;
    height: 32px;
    opacity: 1;
  }
  to {
    width: 32px;
    height: 32px;
    opacity: 0.1;
  }
}
.blinking {
  animation: wxBlinking 1s infinite alternate;
}
.warningBox33 {
  position: absolute;
  bottom: px2vw(50);
  /* left: 1490px; */
  right: px2vw(30);
  z-index: 999;
  /* background-color: aqua; */
  width: px2vw(400);
  height: px2vw(300);
}
.warningBox55 {
  position: absolute;
  bottom: px2vw(50);
  /* left: 1490px; */
  left: px2vw(30);
  z-index: 999;
  /* background-color: aqua; */
  width: px2vw(400);
  height: px2vw(300);
}
.weatherTitle {
  width: px2vw(400);
  height: px2vw(46);
  background-image: url("../assets/Group_48097197.png");
  /* background-color: aqua; */
  background-size: cover;
}
.warningMainBox {
  width: px2vw(400);
  height: px2vw(260);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    270deg,
    rgba(34, 67, 77, 0.6) 0%,
    rgba(29, 62, 70, 1) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(
    270deg,
    rgba(17, 32, 37, 0.1) 0%,
    rgba(22, 39, 45, 0.5) 100%
  );
  padding: px2vw(5);
  overflow-y: auto;
  overflow-x: hidden;
}
.el-checkbox__label {
  color: black !important;
}
.warningBtn {
  width: px2vw(42);
  height: px2vw(19);
  background-image: url("../assets/Group_1321314701.png");
  background-size: cover;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: px2vw(12);
  color: #c5f3f8;
  text-align: center;
  line-height: px2vw(19);
  background-size: cover;
}
.warningBtn22 {
  width: px2vw(30);
  height: px2vw(19);
  background-image: url("../assets/Group_1321314701.png");
  background-size: cover;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: px2vw(12);
  color: #c5f3f8;
  text-align: center;
  line-height: px2vw(19);
  background-size: cover;
}
.waringtext {
  width: px2vw(300);
  height: auto;
}
.warningMainBoxItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: px2vw(380);
  height: px2vw(38);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.17) 0%,
    rgba(255, 255, 255, 0.17) 8.61%,
    rgba(255, 255, 255, 0.17) 90.61%,
    rgba(0, 0, 0, 0.17) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: rgba(0, 195, 255, 0.68);
  box-shadow: 0px 0px 9px rgba(160, 211, 233, 0.08) inset;
  color: rgba(198, 248, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(14);
  line-height: px2vw(38);
  padding: 0px px2vw(5);
  margin-top: px2vw(10);
  font-weight: 700;
}
.warningMainBoxItem22 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: px2vw(380);
  // height: px2vw(58);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.17) 0%,
    rgba(255, 255, 255, 0.17) 8.61%,
    rgba(255, 255, 255, 0.17) 90.61%,
    rgba(0, 0, 0, 0.17) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: rgba(0, 195, 255, 0.68);
  // background: rgba(27, 55, 67, 0.68);
  // background: rgba(161, 161, 161, 0.68);
  box-shadow: 0px 0px 9px rgba(160, 211, 233, 0.08) inset;
  color: rgba(198, 248, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(14);
  // line-height: px2vw(38);
  padding: 0px px2vw(5);
  margin-top: px2vw(10);
  font-weight: 700;
}
.weatherTitText {
  // width: px2vw(78);
  height: px2vw(22);
  position: relative;
  top: px2vw(18);
  left: px2vw(18);
  text-align: left;
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: DingTalk JinBuTi;
  font-size: px2vw(18);
  line-height: 120.000005%;
  letter-spacing: 10%;
}
.showCanclick {
  text-decoration: #0073ff underline;
}
</style>